function Footer() {
  return (
    <>
      <footer className="pt-lg-7 pt-5 footer bg-primary">
        <div className="container mt-lg-2">
          <div className="row">
            <div className="col-lg-4 col-md-6 col-12">
              <div className="mb-4">
                <img
                  src="/assets/images/logo.png"
                  alt="Tikasa Amruttulya Logo"
                  className="logo-inverse"
                  width="90"
                />
                <div className="mt-4">
                  <p className="mb-2 text-white">
                    Welcome to <u>Tikasa Amruttulya</u>
                  </p>
                  <p className="lh-sm text-white">
                    Maharashtra's most-loved{" "}
                    <u>Jaggery Tea (Gud Ki Chai) &amp; Mumbai Vadapav</u>, now a
                    low-investment franchise opportunity.
                  </p>
                  <p className="lh-sm text-white">
                    Tikasa brings together <u>Jaggery Tea and Mumbai Vadapav</u>{" "}
                    under one trusted, supported brand — built for first-time
                    entrepreneurs and seasoned operators alike, with zero
                    royalty fees and end-to-end setup support.
                  </p>
                  <div className="fs-4 mt-5">
                    <a href="#" className="me-3">
                      <i className="bi bi-facebook fs-3 text-light"></i>
                    </a>
                    <a href="#" className="me-3">
                      <i className="bi bi-twitter-x fs-3 text-light"></i>
                    </a>
                    <a href="#" className="me-3">
                      <i className="bi bi-youtube fs-3 text-light"></i>
                    </a>
                    <i className="bi bi-instagram fs-3 text-light"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-3 col-6 d-lg-block d-none"></div>
            <div className="offset-lg-1 col-lg-2 col-md-3 col-6">
              <div className="mb-4">
                <h4 className="fw-normal mb-3 text-white">Company</h4>
                <ul className="list-unstyled nav nav-footer flex-column nav-x-0">
                  <li>
                    <a href="#" className="nav-link text-white">
                      Home
                    </a>
                  </li>
                  <li>
                    <a href="#" className="nav-link text-white">
                      About Us
                    </a>
                  </li>
                  <li>
                    <a href="#" className="nav-link text-white">
                      Our Menu
                    </a>
                  </li>
                  <li>
                    <a href="#" className="nav-link text-white">
                      Franchise Model
                    </a>
                  </li>
                  <li>
                    <a href="#" className="nav-link text-white">
                      Terms Of Services
                    </a>
                  </li>
                  <li>
                    <a href="#" className="nav-link text-white">
                      Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a href="#" className="nav-link text-white">
                      FAQs
                    </a>
                  </li>
                  <li>
                    <a href="#" className="nav-link text-white">
                      Contact Us
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-md-12">
              <div className="mb-4">
                <h4 className="fw-normal mb-3 text-white">
                  Get In Touch &nbsp;&mdash;&nbsp; Contact Us
                </h4>
                <p className="mb-1 text-white lh-sm">
                  Rais Aaragya Building no. 3, office no. 8, C wing, Kalyan East
                  - 421306, Thane, Maharashtra
                </p>
                <p className="mb-1 text-white">
                  Email:{" "}
                  <a
                    href="mailto:franchise@tikasaamruttulya.com"
                    className="text-light"
                  >
                    franchise@tikasaamruttulya.com
                  </a>
                </p>
                <p className="text-white">
                  Phone:
                  <br />
                  <span className="text-light fw-semibold">
                    +91 99211 11101
                  </span>
                  <br />
                  <span className="text-light fw-semibold">
                    +91 88055 56262
                  </span>
                  <br />
                  <span className="text-light fw-semibold">
                    +91 87093 85315
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div className="pt-3">
            <h4 className="text-light">About Tikasa Amruttulya</h4>
            <p className="lh-sm">
              <u>Tikasa Amruttulya</u> stands for bold, distinctive flavour —
              the name <u>Tikasa</u> reflects our unique taste identity, while{" "}
              <u>Amruttulya</u> honours the timeless tradition of serving tea as
              precious as nectar. We bring together Maharashtra's signature
              Jaggery Tea (Gud Ki Chai) and authentic Mumbai Vadapav under one
              proven, scalable franchise model.
            </p>
            <p className="lh-sm">
              Driven by innovation, operational excellence, and entrepreneurial
              growth, <u>Tikasa Amruttulya</u> hands franchise partners a
              capital-light business rooted in traditional Indian flavours —
              backed by full setup support, interior design, and complete staff
              training before opening day. This makes it one of the most
              accessible <u>jaggery tea franchise opportunities</u> for
              entrepreneurs across Tier 1, Tier 2, and Tier 3 cities.
            </p>
            <p className="lh-sm">
              With a dual-product model of <u>Jaggery Tea and Vadapav</u> served
              under one counter, Tikasa outlets are designed to be capital-light
              and quick to earn, requiring just <u>80 – 150 sq. ft.</u> of floor
              space and a total investment of <u>Rs. 2 – 3 Lakhs</u>. From
              premium ingredient sourcing to attentive customer service, every
              detail is carefully curated to build a brand customers keep coming
              back to.
            </p>
            <h4 className="text-light">
              Why Choose Tikasa Amruttulya – A Complete Franchise Experience
            </h4>
            <p className="lh-sm">
              Choosing the right franchise partner can transform your
              entrepreneurial journey, and <u>Tikasa Amruttulya</u> aims to
              exceed expectations at every level. Backed by the team behind{" "}
              <u>250+ jaggery-tea outlets nationwide</u>, Tikasa offers{" "}
              <u>
                zero royalty fees, low investment, and end-to-end franchise
                support
              </u>{" "}
              that makes every partnership rewarding.
            </p>
            <p className="lh-sm">
              One of the key reasons entrepreneurs prefer{" "}
              <u>Tikasa over other tea franchises</u> is its dual-product model.
              Owning a <u>Tikasa outlet</u> means offering both Jaggery Tea and
              Mumbai Vadapav under one roof, increasing footfall and average
              order value. This makes it an ideal <u>tea franchise India</u>{" "}
              choice for <u>first-time entrepreneurs and seasoned operators</u>{" "}
              alike.
            </p>
            <p className="lh-sm">
              <u>
                Tikasa Amruttulya is known for its complete franchise support.
              </u>{" "}
              The dedicated team ensures personalized guidance, quick
              onboarding, and a <u>hands-on training experience</u> that
              reflects genuine care for partner success. From application to
              grand opening, franchisees enjoy seamless support, making{" "}
              <u>
                Tikasa one of the most reliable jaggery tea franchises in India
              </u>
              .
            </p>
            <h4 className="text-light">Key Highlights of Tikasa Amruttulya</h4>
            <p className="lh-md">
              <ul>
                <li>
                  <u>Dual-Product Model</u>: Jaggery Tea and Mumbai Vadapav
                  under one counter
                </li>
                <li>
                  <u>Low Investment</u>: Total franchise investment of just Rs.
                  2 – 3 Lakhs
                </li>
                <li>
                  <u>Zero Royalty Fees</u>: Keep more of what you earn, every
                  single month
                </li>
                <li>
                  <u>Compact Footprint</u>: Only 80 – 150 sq. ft. of floor space
                  required
                </li>
                <li>
                  <u>5-Year Renewable Agreement</u>: Long-term, secure franchise
                  partnership
                </li>
                <li>
                  <u>Complete Staff Training</u>: Recipes, service and hygiene
                  standards before launch
                </li>
                <li>
                  <u>Interior &amp; Store Design</u>: Branded design support for
                  every outlet
                </li>
                <li>
                  <u>Proven Track Record</u>: Backed by 250+ jaggery-tea outlets
                  nationwide
                </li>
                <li>
                  <u>Trusted Leadership</u>: Guided by directors with decades of
                  FMCG and F&amp;B expertise
                </li>
              </ul>
            </p>
            <h4 className="text-light">
              A Preferred Choice Among Tea &amp; Beverage Franchises
            </h4>
            <p className="lh-sm">
              <u>Tikasa Amruttulya</u> has established itself as a benchmark for
              quality and consistency among{" "}
              <u>jaggery tea franchises in India</u>. Its commitment to natural,
              never-refined sweeteners while offering authentic Maharashtrian
              and Mumbai flavours sets it apart from other tea franchises.
              Whether you are searching for the best{" "}
              <u>
                low-investment franchise for entrepreneurs, tier 2 and tier 3
                cities, or first-time business owners
              </u>
              , Tikasa delivers a model that is both profitable and sustainable.
            </p>
            <p className="lh-sm">
              The brand's naturally sweetened menu, combined with strong
              franchise infrastructure, makes it a preferred{" "}
              <u>tea and vadapav franchise</u> option for partners who value
              simplicity, scalability, and success. Tikasa continuously evolves
              its offerings to meet changing consumer preferences, ensuring it
              remains one of the{" "}
              <u>fastest-growing jaggery tea brands in India</u>.
            </p>
          </div>

          <div className="row align-items-center g-0 footer-border py-3 mt-8 bg-white rounded-top-4">
            <div className="d-flex justify-content-center">
              <p className="text-dark m-0 text-center merriweather d-flex">
                Copyright © 2026 Tikasa Amruttulya
                <span className="d-lg-block d-none">
                  , Jaggery Tea &amp; Vadapav Franchise
                </span>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
